module.exports = __webpack_public_path__ + "static/media/ssh-keys.f37446d6.svg";